// The cardboard toy-box lid shared by the Lobby Playground and the Podium (§6.1, §6.6): a rounded
// rectangle 16 × 12 m, x ∈ [−8, 8], y ∈ [−6, 6], corner radius 1.5. A leaf module (no sim
// imports), so either map can build its geometry at load time from any entry point.
import type { RoundedRect } from './geometry';

export const LID: RoundedRect = { cx: 0, cy: 0, hx: 8, hy: 6, r: 1.5 };
